'use client';

import { useTranslations } from 'next-intl';
import { normalizeApiError } from './normalizeApiError';

export const useServerMessage = () => {
  const t = useTranslations('common');

  const translateCode = (code?: string, fallback?: string) => {
    const key = `serverMessages.${code}`;
    console.log('keeeeeeeey', key, code, t.has(key));
    if (code && t.has(key)) {
      return t(key);
    }
    return fallback || t('serverMessages.INTERNAL_ERROR');
  };

  const translateError = (error: unknown) => {
    const { code, message } = normalizeApiError(error);
    return translateCode(code, message);
  };

  return { translateCode, translateError };
};
